<template>
  <div>
    <el-dialog title="Clear balance" :visible.sync="dialogForm">
      <el-form
        :model="clearBalanceForm"
        ref="ClearBalanceForm"
        label-width="170px"
        size="small"
        :rules="clearBalanceFormRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-form-item label="Name" prop="senderName">
          <el-input v-model="clearBalanceForm.senderName"></el-input>
        </el-form-item>
        <el-form-item
          :label="
            clearBalanceForm.currency == 'GBP' ? 'Account Number' : 'IBAN'
          "
          prop="accountNumberIban"
        >
          <el-input v-model="clearBalanceForm.accountNumberIban"></el-input>
        </el-form-item>
        <el-form-item
          :label="
            clearBalanceForm.currency == 'GBP' ? 'Sort Code' : 'Swift / BIC'
          "
          prop="sortcodeSwift"
        >
          <el-input v-model="clearBalanceForm.sortcodeSwift"></el-input>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input type="number" v-model="clearBalanceForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input v-model="clearBalanceForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogForm = false">Cancel</el-button>
        <el-button
          :loading="submitingClearBalance"
          type="primary"
          @click="submitClearBalance()"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postClearBalance } from "@/api/transaction";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
  },
  data() {
    return {
      dialogForm: false,
      submitingClearBalance: false,
      bankholderId: "",
      clearBalanceForm: {
        currency: "",
        senderName: "",
        accountNumberIban: "",
        sortcodeSwift: "",
        amount: "",
        remark: "",
      },
      clearBalanceFormRule: {
        senderName: [
          {
            required: true,
            message: "Please enter name",
            trigger: "blur",
          },
        ],
        accountNumberIban: [
          {
            required: true,
            message: "Please enter Account Number / IBAN",
            trigger: "blur",
          },
        ],
        sortcodeSwift: [
          {
            required: true,
            message: "Please enter Sort Code / BIC",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "Please enter remark",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    clearForm() {
      this.clearBalanceForm.currency = "";
      this.clearBalanceForm.senderName = "";
      this.clearBalanceForm.accountNumberIban = "";
      this.clearBalanceForm.sortcodeSwift = "";
      this.clearBalanceForm.amount = "";
      this.clearBalanceForm.remark = "";
    },
    show(bankholderId, currency) {
      this.clearForm();
      this.bankholderId = bankholderId;
      this.clearBalanceForm.currency = currency.toUpperCase();
      this.submitingClearBalance = false;
      this.dialogForm = true;
    },
    submitClearBalance() {
      this.$refs.ClearBalanceForm.validate((valid) => {
        if (valid) {
          this.submitingClearBalance = true;
          let model = { ...this.clearBalanceForm };
          model.amount = Number(this.clearBalanceForm.amount);
          postClearBalance(this.bankholderId, model).then(
            ({ result, message }) => {
              this.submitingClearBalance = false;
              if (result) {
                this.$notify({
                  title: "Success",
                  message: `Clear balancr successfully`,
                  type: "success",
                  duration: 2000,
                });
                this.dialogForm = false;
                this.$emit("submited");
              }
            }
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
